import { IOrderSelectedBonus } from '../../../../../../graphql/order/models/get-orders.models';

export const getCoveredPackages = (voucher?: IOrderSelectedBonus | null): number => {
  const rules = voucher?.rules;

  return rules?.exactAmountOfProductsRule?.amount ?? rules?.matchAmountWithProductRule?.amount ?? 0;
};
